import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, isInvalid } from 'redux-form'
import { Button } from 'react-bootstrap'

import * as actions from '../../../actions'
import CamposIngresoCompleto2 from
  '../../../components/iCompleto/CamposIngresoCompleto2'
import { FORM_INGRESO_COMPLETO } from '../../../../../config/forms'
import StatusModal from
  '../../../../Forms/SharedComponents/containers/StatusModal'
import { mensajeUsuario, mensajeContexto } from '../../../../../helpers/message'
import { ToastContainer } from 'react-toastify'

// iCompletoSatus
class IngresoCompleto2 extends Component {
  constructor (props) {
    super(props)
    this.hideSaveMessageModal = this.hideSaveMessageModal.bind(this)
  }

  prepareEntities (cpa) {
    const {
      mercadoATermino,
      vendedor,
      intermediario,
      intermediarioFlete
    } = cpa
    return {
      searchSet: [
        { entity: 'cargador', value: intermediario },
        { entity: 'corredor', value: mercadoATermino },
        { entity: 'vendedor', value: vendedor },
        { entity: 'transportista', value: intermediarioFlete }
      ],
      fields: ['intermediario', 'mercadoATermino', 'vendedor',
        'intermediarioFlete']
    }
  }

  hideSaveMessageModal () {
    this.props.hideSaveMessageModal()
  }

  componentDidMount () {
    const {
      currentCpa: cpa,
      change: formChange,
      updateLocalidad,
      iCompletoUpdateEntities
    } = this.props
    iCompletoUpdateEntities(this.prepareEntities(cpa), formChange)
    updateLocalidad(cpa.localidad, formChange)
  };

  render () {
    const {
      handleSubmit,
      onPrev,
      currentCpa = null,
      invalid,
      iCompletoSaveResponse,
      iCompletoShowSaveModal
    } = this.props

    return (
      <div>
        <ToastContainer />
        <StatusModal
          show={iCompletoShowSaveModal}
          onClick={this.hideSaveMessageModal}
          errorMessage={mensajeUsuario(iCompletoSaveResponse)}
          extraErrorMessage={mensajeContexto(iCompletoSaveResponse)}
        />
        <h3>Ingreso de datos para {currentCpa.numero ? currentCpa.numero : currentCpa.codigoCupo}</h3>
        <CamposIngresoCompleto2 />
        <br />
        <Button
          type='button'
          onClick={() => onPrev()}
          size='lg'
        >Atras</Button>{'  '}
        <Button
          type='submit'
          onClick={() => handleSubmit()}
          disabled={invalid}
          size='lg'
        >Siguiente</Button>
        <br />
      </div>
    )
  };
};

const mapStateToProps = (state) => ({
  currentCpa: state.camionesIngreso.iCompletoCpa,
  invalid: isInvalid(FORM_INGRESO_COMPLETO)(state),
  iCompletoSaveResponse: state.camionesIngreso.iCompletoSaveResponse,
  iCompletoShowSaveModal: state.camionesIngreso.iCompletoShowSaveModal
})

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_INGRESO_COMPLETO,
  destroyOnUnmount: false
})

export default withRedux(withReduxForm(IngresoCompleto2))
